// liveStreamCap.js — WSX (forense Pro Esporte). Teto no acumulador VIVO de streaming.
//
// A bolha viva concatena `s.content += delta` / `s.reasoning += delta` a cada token.
// Num loop de reasoning que pinga pra sempre sem concluir, essa string cresce sem
// limite → o "aumento gigante de RAM" reportado. O teto ABSOLUTO por chamada no
// agentLoop já mata o loop; este helper é defense-in-depth: mantém só a CAUDA (o
// pensamento mais recente é o relevante ao vivo), com um marcador do que caiu.
//
// PURO, sem I/O. O conteúdo FINAL persistido vem do evento `assistant` (evt.content),
// não daqui — então capar o preview vivo NUNCA corrompe a resposta persistida.

// 256 KB por campo: reasoning/resposta única legítima jamais chega perto; só a
// patologia (MB de reasoning em loop) é truncada.
export const LIVE_STREAM_MAX_CHARS = 256 * 1024;

/**
 * Concatena `delta` ao acumulado; se passar de `max`, mantém a CAUDA de `max` chars
 * (com um marcador de truncamento no início). Alocação simples quando cabe.
 * @param {string} prev
 * @param {string} delta
 * @param {number} [max]
 * @returns {string}
 */
export function appendCapped(prev, delta, max = LIVE_STREAM_MAX_CHARS) {
  const next = (prev || '') + (delta || '');
  if (next.length <= max) return next;
  const marker = `…[live truncado: +${next.length - max} chars]\n`;
  // Resultado sempre com exatamente `max` chars (marker + cauda). Se `max` for menor
  // que o marcador (misconfig — o default é 256KB), devolve só a cauda crua.
  if (marker.length >= max) return next.slice(next.length - max);
  return marker + next.slice(next.length - max + marker.length);
}
